import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('organizationNameField');

    return {
        ORGANIZATION_NAME_FIELD_LABEL: t('organizationNameFieldLabel')
    };
};

export default useTranslation;
